export default __webpack_public_path__ + "fonts/327989b50661ec99c814b6ec7d67402c.svg";